import Icon from '@components/v2/ui/Icon/Icon';
import { MenuItem as MuiMenuItem } from '@mui/material';
import { Plus } from 'lucide-react';
import AutocompleteOption from '../../Autocomplete/components/AutocompleteOption';
import { AsyncAutocompleteOptionProps } from '../asyncAutocomplete.types';

const AsyncAutocompleteOption = ({
  props,
  option,
  state,
  multiple,
  isCreateOption,
  getOptionLabel,
  renderOption,
}: AsyncAutocompleteOptionProps) => {
  if (isCreateOption) {
    return (
      <MuiMenuItem {...props} sx={{ color: 'primary.main', gap: 1 }}>
        <Icon icon={Plus} size="md" />
        {getOptionLabel(option)}
      </MuiMenuItem>
    );
  }

  if (!renderOption) {
    return (
      <AutocompleteOption
        props={props}
        option={option}
        state={state}
        multiple={multiple}
        getOptionLabel={getOptionLabel}
      />
    );
  }

  return (
    <MuiMenuItem {...props} disableGutters selected={state.selected}>
      {renderOption(option)}
    </MuiMenuItem>
  );
};

export default AsyncAutocompleteOption;
